var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"appear":"","name":"scale"}},[_c('div',{staticClass:"modal-plain"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }